/* UI boundary: all optimizers, plan payloads and cart properties still use mm. */
(() => {
  const selector = '[data-length], [data-width]';
  const rootOf = element => element.closest('.fibrolux-zuschnitt--finder-ui');
  const factorOf = element => rootOf(element)?.dataset.inputUnit === 'cm' ? 10 : 1;
  const clean = value => Math.round(Number(value) * 1e6) / 1e6;
  const toMillimetres = input => input ? clean(Number(input.value || 0) * factorOf(input)) : 0;
  const setMillimetres = (input, value) => { if (input) input.value = String(clean(Number(value) / factorOf(input))); };

  function prepare(container) {
    container.querySelectorAll(selector).forEach(input => {
      if (!input.dataset.unitReady) {
        input.dataset.unitReady = 'true';
        input.dataset.minMm = input.getAttribute('min') || '';
        input.dataset.maxMm = input.getAttribute('max') || '';
        input.dataset.placeholderMm = input.placeholder || '';
        const label = input.parentElement.querySelector('span');
        if (label) input.dataset.labelMm = label.textContent;
      }
      const unit = factorOf(input) === 10 ? 'cm' : 'mm';
      const factor = factorOf(input);
      for (const bound of ['min', 'max']) {
        const value = input.dataset[`${bound}Mm`];
        if (value !== '') input.setAttribute(bound, String(clean(Number(value) / factor)));
        else input.removeAttribute(bound);
      }
      input.step = factor === 10 ? '0.1' : '1';
      input.inputMode = factor === 10 ? 'decimal' : 'numeric';
      input.placeholder = input.dataset.placeholderMm.replace(/\bmm\b/g, unit);
      const label = input.parentElement.querySelector('span');
      if (label) label.textContent = (input.dataset.labelMm || '').replace(/\bmm\b/g, unit);
    });
  }

  function setMaxMillimetres(input, maximum) {
    if (!input) return;
    if (!input.dataset.unitReady) prepare(input.parentElement);
    const valid = maximum && Number.isFinite(Number(maximum));
    input.dataset.maxMm = valid ? String(Math.round(Number(maximum))) : '';
    if (valid) input.max = String(clean(Number(input.dataset.maxMm) / factorOf(input)));
    else input.removeAttribute('max');
  }

  function hasFractionalMillimetres(container) {
    let invalid = false;
    container.querySelectorAll(selector).forEach(input => {
      const mm = toMillimetres(input);
      const fraction = input.value !== '' && (!Number.isFinite(mm) || !Number.isInteger(mm));
      if (fraction) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
      invalid ||= fraction;
    });
    return invalid;
  }

  function errorText(container) {
    return rootOf(container)?.querySelector('[data-unit-error]')?.dataset.unitError || 'Bitte in Schritten von 1 mm bzw. 0,1 cm eingeben.';
  }

  function setUnit(root, next) {
    if (!['mm', 'cm'].includes(next) || root.dataset.inputUnit === next) return;
    const values = Array.from(root.querySelectorAll(selector), input => ({ input, empty: input.value === '', mm: toMillimetres(input) }));
    root.dataset.inputUnit = next;
    prepare(root);
    values.forEach(({input, empty, mm}) => {
      if (!empty) setMillimetres(input, mm);
    });
    root.querySelectorAll('[data-size-unit]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.sizeUnit === next));
    });
    // Conversion alone does not recalculate: the canonical dimensions have not changed.
  }

  function init(root) {
    if (root.dataset.unitsInitialized) return;
    root.dataset.unitsInitialized = 'true';
    root.dataset.inputUnit = 'mm';
    prepare(root);
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-size-unit]');
      if (button && root.contains(button)) setUnit(root, button.dataset.sizeUnit);
    });
  }

  window.FibroluxCutUnits = { init, prepare, toMillimetres, setMillimetres, setMaxMillimetres, hasFractionalMillimetres, errorText, setUnit };
})();
